// extracted by mini-css-extract-plugin
export default {"blog":"styles_blog__MMtso","blog__link":"styles_blog__link__6Nu82","item":"styles_item__fQUh3","item__in":"styles_item__in__UR9hL"};